import {print, stripIgnoredCharacters} from 'graphql';

export default function documentToQueryString(document) {
	return stripIgnoredCharacters(print(document));
}
